// src/components/shared/ThemeToggle.js
// Bouton de changement de thème clair/sombre - NE PAS MODIFIER

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const ThemeToggle = ({ compact = false }) => {
  const { theme, isDark, toggleTheme } = useTheme();

  const styles = {
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: compact ? '36px' : '40px',
      height: compact ? '36px' : '40px',
      borderRadius: '50%',
      backgroundColor: theme.bgInput,
      border: `1px solid ${theme.border}`,
      color: theme.gold,
      fontSize: compact ? '16px' : '18px',
      cursor: 'pointer',
      transition: 'all 250ms ease-in-out',
      flexShrink: 0,
    },
  };

  return (
    <button
      style={styles.button}
      onClick={toggleTheme}
      aria-label={isDark ? 'Mode clair' : 'Mode sombre'}
      title={isDark ? 'Mode clair' : 'Mode sombre'}
    >
      {isDark ? '☀️' : '🌙'}
    </button>
  );
};

export default ThemeToggle;